/**
 * BD AI chat widget - configuration.
 * Props passed to <BDAIChat /> (apiBaseUrl, empCode, ...) take priority over these values.
 */
const BDAI_CONFIG = {
  // Django server. App.js passes BASE_URL from config/axios.js, which overrides this.
  API_BASE_URL: "https://bkzrdhbv-8008.inc1.devtunnels.ms",

  // MUST match the path in django_project/urls.py:
  //   path("api/bd-ai/", include("bd_ai.urls"))  ->  "/api/bd-ai"
  //   path("bd-ai/", include("bd_ai.urls"))      ->  "/bd-ai"
  API_PREFIX: "/bd_ai",

  // Same token your app uses (config/axios.js reads sessionStorage "access_token")
  getAuthHeaders: () => {
    try {
      const token = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
      return token ? { Authorization: `Bearer ${token}` } : {};
    } catch (e) {
      return {};
    }
  },

  // Logged-in employee code (App.js passes empCode, which overrides this)
  getEmpCode: () => {
    try {
      return sessionStorage.getItem("emp_code") || localStorage.getItem("emp_code") || "";
    } catch (e) {
      return "";
    }
  },

  ASSISTANT_NAME: "BD Assistant",

  FALLBACK_SUGGESTIONS: [
    "Give me a weekly progress report: what moved to final, bid prep and submitted.",
    "How many tenders are in each tab right now, by sector?",
    "Which tenders are due in the next 7 days and not yet submitted?",
    "Team lead wise performance this month.",
    "Who cancelled or rejected tenders last month and why?",
    "Total EMD submitted this month by bank, and how much was released?",
    "Which bank guarantees expire in the next 30 days?",
    "Which competitors beat us most often on price?",
  ],

  FOLLOW_UPS: [
    "Break this down team lead wise",
    "Show it month-wise",
    "Only Highway sector",
    "Only Railway sector",
    "List the tenders",
    "Compare with the previous period",
  ],

  MAX_QUESTION_LENGTH: 2000,
  REQUEST_TIMEOUT_MS: 180000,
  ENABLE_SHORTCUT: true,
};

export default BDAI_CONFIG;